// Shared desktop sizing for the bio clip players (the swipe deck and the
// standalone single-video page), so the two surfaces stay visually consistent.
//
// `--player-card-h` is the desktop card height, capped so the 9:16 video column
// PLUS an equal-width comments panel always fit the viewport: the
// `(100vw - 3rem)/2 * 16/9` term bounds the height so two columns + a 3rem
// gutter never overflow (kicks in on narrow windows / when devtools is docked),
// while 80dvh / 900px cap it on tall, wide screens. The column width derives
// from it, so opening comments never resizes the video.
export const DESKTOP_CARD_HEIGHT =
  'min(80dvh, 900px, calc((100vw - 3rem) / 2 * 16 / 9))';
export const DESKTOP_COLUMN_WIDTH = 'calc(var(--player-card-h) * 9 / 16)';
